export interface IWarehouseAdminOrderBuildingReportOrderData {
    id: number;
    number: string|null;
    status: string;
    created: string;
    closed: string|null;
    loaded: string|null;
    delivered: string|null;
    requested: number;
    loaded_amount: number|null;
    delivered_amount: number|null;
    returned_amount: number|null;
    retoured_amount: number|null;
    building: string;
}

export interface IWarehouseAdminOrderBuildingReportData {
    product: {
        id: number;
        name: string|null;
    };
    building: string;
    totals: {
        requested: number;
        loaded: number;
        delivered: number;
        returned: number;
        retoured: number;
    };
    orders: IWarehouseAdminOrderBuildingReportOrderData[];
}

export class WarehouseAdminOrderBuildingReportOrderData {
    id: number;
    number: string|null;
    building: string;
    status: string;
    created: string;
    closed: string|null;
    loaded: string|null;
    delivered: string|null;
    requested: number;
    loaded_amount: number|null;
    delivered_amount: number|null;
    returned_amount: number|null;
    retoured_amount: number|null;

    constructor(data: IWarehouseAdminOrderBuildingReportOrderData) {
        this.id = Number(data.id);
        this.number = data.number ?? null;
        this.building = data.building;
        this.status = data.status;
        this.created = data.created;
        this.closed = data.closed ?? null;
        this.loaded = data.loaded ?? null;
        this.delivered = data.delivered ?? null;
        this.requested = Number(data.requested ?? 0);
        this.loaded_amount = data.loaded_amount == null ? null : Number(data.loaded_amount);
        this.delivered_amount = data.delivered_amount == null ? null : Number(data.delivered_amount);
        this.returned_amount = data.returned_amount == null ? null : Number(data.returned_amount);
        this.retoured_amount = data.retoured_amount == null ? null : Number(data.retoured_amount);
    }
}

export default class WarehouseAdminOrderBuildingReportData {
    product: {
        id: number;
        name: string|null;
    };
    building: string;
    totals: {
        requested: number;
        loaded: number;
        delivered: number;
        returned: number;
        retoured: number;
    };
    orders: WarehouseAdminOrderBuildingReportOrderData[];

    constructor(data: IWarehouseAdminOrderBuildingReportData) {
        this.product = {
            id: Number(data.product.id),
            name: data.product.name ?? null
        };
        this.building = data.building;
        this.totals = {
            requested: Number(data.totals.requested ?? 0),
            loaded: Number(data.totals.loaded ?? 0),
            delivered: Number(data.totals.delivered ?? 0),
            returned: Number(data.totals.returned ?? 0),
            retoured: Number(data.totals.retoured ?? 0)
        };
        this.orders = (data.orders ?? []).map(order => new WarehouseAdminOrderBuildingReportOrderData(order));
    }
}